export default "__VITE_ASSET__DSZdhJJc__"